import throttle from 'lodash/throttle';

if (!document.body.classList.contains('wp-admin')) {
	document.addEventListener('DOMContentLoaded', function () {
		const mediaBlocks = document.querySelectorAll('.block-media-standard');

		mediaBlocks.forEach((block) => {
			const hasVideoButton = block.querySelector(
				'.component-video__play-button'
			);

			if (!hasVideoButton) return;

			const container = block.querySelector('.container');
			if (!container) return;

			const computedStyle = window.getComputedStyle(container);
			const defaultPaddingLeft =
				parseFloat(computedStyle.paddingLeft) || 15;
			const defaultPaddingRight =
				parseFloat(computedStyle.paddingRight) || 15;

			container.style.transition = 'padding 0.3s ease-out';

			let lastScrollY = window.scrollY;
			let hasReachedFullWidth = false;

			const handleScroll = throttle(() => {
				const rect = block.getBoundingClientRect();
				const windowHeight = window.innerHeight;
				const currentScrollY = window.scrollY;
				const isScrollingUp = currentScrollY < lastScrollY;

				const scrollStart = windowHeight * 0.8;
				const scrollEnd = windowHeight * 0.2;

				if (rect.top < scrollStart && rect.bottom > scrollEnd) {
					let progress = 0;

					if (rect.top >= scrollEnd) {
						progress =
							(scrollStart - rect.top) /
							(scrollStart - scrollEnd);
					} else {
						progress = 1;
					}

					progress = Math.max(0, Math.min(1, progress));

					if (progress === 1) {
						hasReachedFullWidth = true;
					}

					if (hasReachedFullWidth && !isScrollingUp) {
						progress = 1;
					} else if (isScrollingUp && rect.top > scrollEnd) {
						hasReachedFullWidth = false;
					}

					const currentPaddingLeft =
						defaultPaddingLeft * (1 - progress);
					const currentPaddingRight =
						defaultPaddingRight * (1 - progress);

					container.style.paddingLeft = `${currentPaddingLeft}px`;
					container.style.paddingRight = `${currentPaddingRight}px`;
				} else {
					if (rect.top >= scrollStart) {
						hasReachedFullWidth = false;
					}
					container.style.paddingLeft = `${defaultPaddingLeft}px`;
					container.style.paddingRight = `${defaultPaddingRight}px`;
				}

				lastScrollY = currentScrollY;
			}, 16);

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							window.addEventListener('scroll', handleScroll, {
								passive: true,
							});
							handleScroll();
						} else {
							window.removeEventListener('scroll', handleScroll);
							container.style.paddingLeft = `${defaultPaddingLeft}px`;
							container.style.paddingRight = `${defaultPaddingRight}px`;
						}
					});
				},
				{
					rootMargin: '100px',
				}
			);

			observer.observe(block);
		});
	});
}
